import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=2baf3432&"
import script from "./swiper.vue?vue&type=script&lang=js&"
export * from "./swiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2baf3432')) {
      api.createRecord('2baf3432', component.options)
    } else {
      api.reload('2baf3432', component.options)
    }
    module.hot.accept("./swiper.vue?vue&type=template&id=2baf3432&", function () {
      api.rerender('2baf3432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/swiper/src/swiper.vue"
export default component.exports